
export class NotificationsService {

  private isSubscribed: boolean = false;
  private publicVapidKey: string = '';
  private subscriptionEndpoint: string = '';
  private userId: string = '';

  public setPublicVapidKey(key: string) {
    this.publicVapidKey = key;
  }
  public setSubscriptionEndpoint(endpoint: string) {
    this.subscriptionEndpoint = endpoint;
  }
  public setUserId(id: string) {
    this.userId = id;
  }

  public async init() {

    if ('serviceWorker' in navigator && 'PushManager' in window) {
      let swRegistration = await navigator.serviceWorker.getRegistration();
      if (swRegistration === undefined) {
        swRegistration = await navigator.serviceWorker.register("/w/sw.js", {
          scope: "/",
        });
      }
      let subscription = await swRegistration.pushManager.getSubscription();

      if (subscription) {
        this.isSubscribed = true;
      }

      if (subscription === null && Notification.permission !== 'denied') {
        subscription = await this.subscribe(swRegistration);
        this.updateSubscriptionOnServer(subscription, this.userId);
        this.isSubscribed = true;
      }
    }
    return this.isSubscribed;
  }

  private async subscribe(registration: any) {
    return registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: this.urlB64ToUint8Array(this.publicVapidKey),
    });
  }

  private async updateSubscriptionOnServer(userSubscription: any, userEmail: string) {
    if (userSubscription && userEmail !== '') {
      await fetch(this.subscriptionEndpoint, {
        method: 'POST',
        body: JSON.stringify({
          subscription: userSubscription,
          email: userEmail,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }
  }

  /*
  // Maybe be this will be useful
  private async unsubscribe(registration: any) {
    registration.pushManager.getSubscription()
      .then((subscription: any) => {
        if (subscription) {
          return subscription.unsubscribe();
        }
      });
  }
  */

  private urlB64ToUint8Array(base64String: string): any {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

}

